// @ts-nocheck
import React, {useEffect, useState} from 'react'

// When an affiliate uses "log in as customer", the new tab stores an
// `affiliate_return` marker holding the affiliate's own auth. This banner lets
// them swap back to their affiliate account without re-logging-in.
const AffiliateImpersonationBanner = () => {
  const [marker, setMarker] = useState<{auth: string; customer?: string} | null>(null)

  useEffect(() => {
    try {
      const raw = localStorage.getItem('affiliate_return')
      if (raw) setMarker(JSON.parse(raw))
    } catch (_) {}
  }, [])

  if (!marker) return null

  const handleReturn = () => {
    try {
      localStorage.setItem('kt-auth-react-v', marker.auth)
      localStorage.removeItem('affiliate_return')
      window.location.href = '/affiliate/customers'
    } catch (_) {}
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1090,
        background: '#1b1b29',
        color: '#fff',
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
      }}
    >
      <span>
        אתה צופה כעת בחשבון של הלקוח{marker.customer ? ` (${marker.customer})` : ''} כשותף.
      </span>
      <button className='btn btn-sm btn-light' onClick={handleReturn}>
        חזרה לחשבון השותף שלי
      </button>
    </div>
  )
}

export default AffiliateImpersonationBanner
